// api/merchant_onboarding.js

import request from '@/utils/request'

let Merchant_onboardingApi = {

  /*入驻码列表*/
  list(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/index', data);
  },

  /*更新下载状态*/
  updatedownload(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/updatedownload', data);
  },

  /*添加入驻码*/
  add(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/add', data);
  },

  /*修改入驻码*/
  edit(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/edit', data);
  },

  /*删除入驻码（单个）*/
  del(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/del', data);
  },

  /*批量删除入驻码*/
  batchDel(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/batchDel', data);
  },

  /*入驻码详情*/
  detail(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/detail', data);
  },

  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.merchant_onboarding.Setting/saveSetting', data, errorback);
  },

  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.merchant_onboarding.Setting/getSetting', data, errorback);
  },

  /*================== 导出相关接口 ==================*/
  /**
   * 导出Excel（普通导出）
   * @param {Object} data 导出参数
   */
  exportExcel(data) {
      return request._get('/shop/plus.merchant_onboarding.Index/exportExcel', data, {
      responseType: 'blob',
      timeout: 300000,
      showLoading: false
    });
  },  /*ZIP分批导出*/
  exportExcelZip(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/batchExportZip', data, {
      responseType: 'blob',
      timeout: 600000, // 10分钟超时
      showLoading: false
    });
  },

  
  /**
   * 导出CSV（普通导出）
   * @param {Object} data 导出参数
   */
  exportCsv(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/exportCsv', data, {
      responseType: 'blob',
      timeout: 300000
    });
  },

  /**
   * 获取导出进度数据（分批导出 - 获取单页数据）
   * @param {Object} data { page: 1, page_size: 100, export_id: 'xxx', ...筛选条件 }
   */
  getExportPage(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/getExportPage', data, {
      showLoading: false,  // 分批导出时不显示loading
      timeout: 60000  // 1分钟超时
    });
  },

  /**
   * 下载合并后的文件（分批导出完成后）
   * @param {Object} data { export_id: 'xxx' }
   */
  downloadExportFile(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/downloadExportFile', data, {
      responseType: 'blob',
      showLoading: true,
      timeout: 300000
    });
  },

  /**
   * 取消导出
   * @param {Object} data { export_id: 'xxx' }
   */
  cancelExport(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/cancelExport', data, {
      showLoading: false
    });
  },

  /**
   * 获取导出状态
   * @param {Object} data { export_id: 'xxx' }
   */
  getExportStatus(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/getExportStatus', data, {
      showLoading: false
    });
  },

  /*================== 图片下载相关接口 ==================*/

  /**
   * 下载单个入驻码图片
   * @param {Object} data { merchant_onboarding_id: 1 }
   */
  downloadImage(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/downloadImage', data, {
      responseType: 'blob',
      showLoading: true
    });
  },

  /**
   * 批量下载入驻码图片（打包成zip）
   * @param {Object} data { merchant_onboarding_ids: [1,2,3] }
   */
  batchDownloadImages(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/batchDownloadImages', data, {
      responseType: 'blob',
      showLoading: true,
      timeout: 600000  // 10分钟超时
    });
  },

  /*================== 供应商相关接口 ==================*/

  /**
   * 获取供应商列表（用于下拉选择）
   * @param {Object} data { keyword: '' }
   */
  getSupplyList(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/getSupplyList', data);
  },

  /*================== 状态更新相关接口 ==================*/

  /**
   * 更新入驻码状态
   * @param {Object} data { merchant_onboarding_id: 1, is_use: 1 }
   */
  updateStatus(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/updateStatus', data);
  },

  /**
   * 批量更新状态
   * @param {Object} data { merchant_onboarding_ids: [1,2,3], is_use: 1 }
   */
  batchUpdateStatus(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/batchUpdateStatus', data);
  },

  /*================== 批量打印接口 ==================*/

  /**
   * 批量打印数据
   * @param {Object} data { merchant_onboarding_ids: [1,2,3] }
   */
  batchPrint(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/batchPrint', data);
  },

  /*================== 导入相关接口 ==================*/

  /**
   * 导出模板（用于导入）
   */
  exportTemplate() {
    return request._post('/shop/plus.merchant_onboarding.Index/exportTemplate', {}, {
      responseType: 'blob',
      showLoading: true
    });
  },

  /**
   * 导入入驻码
   * @param {FormData} formData 包含文件的表单数据
   */
  importData(formData) {
    return request._post('/shop/plus.merchant_onboarding.Index/importData', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000
    });
  },

  /**
   * 获取导入进度
   * @param {Object} data { import_id: 'xxx' }
   */
  getImportProgress(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/getImportProgress', data, {
      showLoading: false
    });
  },

  /**
   * 取消导入
   * @param {Object} data { import_id: 'xxx' }
   */
  cancelImport(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/cancelImport', data);
  },

  /*================== 统计相关接口 ==================*/

  /**
   * 获取统计数据
   * @param {Object} data 筛选条件
   */
  getStatistics(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/getStatistics', data);
  },

  /*================== 导出历史接口 ==================*/

  /**
   * 获取导出历史记录
   * @param {Object} data { page: 1, list_rows: 20 }
   */
  getExportHistory(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/getExportHistory', data);
  },

  /**
   * 下载历史导出文件
   * @param {Object} data { history_id: 1 }
   */
  downloadHistoryFile(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/downloadHistoryFile', data, {
      responseType: 'blob',
      showLoading: true
    });
  },

  /**
   * 删除历史导出记录
   * @param {Object} data { history_id: 1 }
   */
  deleteHistory(data) {
    return request._post('/shop/plus.merchant_onboarding.Index/deleteHistory', data);
  }
}

export default Merchant_onboardingApi;


// WEBPACK FOOTER //
// ./src/api/merchant_onboarding.js